import React, {useEffect, useRef} from 'react';
import {FloatingWindowOpener, InnerWindowAnimator} from "@wix/devzai-utils-react";
import {DoppePageCookieBanner} from "../doppe-page-cookie-banner/doppe-page-cookie-banner";
import {useDoppeViewerClientServices} from "../../../client/doppe-user-app/doppe-viewer-client-services";
import {assertNotNullable} from "@wix/devzai-utils-common";

export const DoppePageCookieBannerOpener = React.memo(function DoppePageCookieBannerOpener (props: DoppeNotificationOpener.Props) {
    const {
        className
    } = props;

    const cookieConsentService = assertNotNullable(useDoppeViewerClientServices().doppeViewerAppCookieService.cookieConsentManager);
    const cookieBannerOpenerRef = useRef<FloatingWindowOpener<{}>>(null);

    useEffect(()=> {
        if (cookieConsentService.shouldAskForConsent()) {
            cookieBannerOpenerRef.current?.open({});
        }
    }, [cookieConsentService, cookieBannerOpenerRef])

    return (
        <FloatingWindowOpener
            ref={cookieBannerOpenerRef}
        >
            {(renderProps) => {
                return (
                    <InnerWindowAnimator
                        windowClosingControllerRef={renderProps.windowClosingControllerRef}
                        openTransition={{
                            animation: [
                                {transform: 'translate(0, 50%)', opacity: 0.5},
                                {transform: 'translate(0, 0)', opacity: 1},
                            ],
                            durationMilliseconds: 200
                        }}
                        closeTransition={{
                            animation: [
                                {transform: 'translate(0, 0)', opacity: 1},
                                {transform: 'translate(0, 50%)', opacity: 0.5},
                            ],
                            durationMilliseconds: 100
                        }}
                    >
                        <DoppePageCookieBanner
                            className={className}
                            onClose={() => {
                                cookieBannerOpenerRef.current?.close();
                            }}
                        />
                    </InnerWindowAnimator>

                )
            }}
        </FloatingWindowOpener>
    );
});

export namespace DoppeNotificationOpener {

    export interface Props {
        className: string;
    }
}
